import CookieConsent from '@/plugins/cookie-consent';
import AxeptioConsent from '@/plugins/axeptio-consent';
import * as Sentry from "@sentry/vue";

const AXEPTIO_CMP_FEATURE_FLAG = 'dev-12096-axeptio-cmp-in-konnect';

export function initConsentBanner(websiteConfig, language, localeCode) {
	const featureFlags = websiteConfig.data.feature_flags || [];
	const isAxeptioCmpEnabled = featureFlags.includes(AXEPTIO_CMP_FEATURE_FLAG);
	const shouldUseAxeptio = isAxeptioCmpEnabled && websiteConfig.data.fields.consent_management_platform === 'axeptio';

	if (shouldUseAxeptio) {
		AxeptioConsent.inject(
			{ clientId: websiteConfig.data.fields.axeptio_project_id, language: localeCode },
			() => Sentry.captureException(new window.Error('Axeptio consent script failed to load')),
		);

		return;
	}

	CookieConsent.inject({
		siteName: websiteConfig.data.name,
		language,
		privacy_policy_url: "https://connectngo.com/privacy-policy",
	});
}
